import { Injectable, Injector } from '@angular/core';
import { Observable, ReplaySubject, tap } from 'rxjs';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';
import { IUserForgotConfirm, IUserResetPassword, UserModel } from '@aeCore/interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class UserService extends ApiService {
  public currentUser$: ReplaySubject<UserModel | null> =
    new ReplaySubject<UserModel | null>();
  public user!: UserModel | null;
  public isLoggedIn: boolean = false;

  constructor(protected override injector: Injector) {
    super(injector);
  }

  getUserInfo(): Observable<UserModel> {
    return this.get<UserModel>(['admin', 'users', 'me']).pipe(
      map((user: UserModel) => new UserModel(user)),
      tap((user: UserModel) => {
        this.currentUser$.next(user);
        this.user = user;
        localStorage.setItem('user', JSON.stringify(user));
      }),
    );
  }

  async hasPermission(
    permission: string | string[] | undefined,
  ): Promise<boolean> {
    if (Array.isArray(permission) && permission.length === 0) {
      return true;
    } else if (!permission) {
      return true;
    }

    if (!this.user) return false;

    if (Array.isArray(permission)) {
      return permission.some((p) => this.user!.permissions!.includes(p));
    } else {
      return this.user.permissions!.includes(permission);
    }
  }

  resetPassword(body: IUserResetPassword): Observable<void> {
    return this.post<void>(['admin', 'users', 'change-password'], body);
  }

  forgotConfirm(body: IUserForgotConfirm): Observable<void> {
    return this.post<void>(['admin', 'users', 'forgot-confirm'], body);
  }
}
